/**
 * Subscribe to the current user's profile doc (users/{uid}) which holds tabAccess.
 * Auto-creates the doc with default access on first login.
 */
import { useEffect, useState } from 'react';
import { doc, onSnapshot, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import { DEFAULT_TAB_ACCESS, OWNER_EMAIL } from '../lib/permissions';

export default function useTabAccess(user) {
  const [tabAccess, setTabAccess] = useState(DEFAULT_TAB_ACCESS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }

    const ref = doc(db, 'users', user.uid);
    let unsub;
    (async () => {
      const snap = await getDoc(ref);
      if (!snap.exists()) {
        // Auto-create. Owner gets full access; others default to same (filter via business.roles).
        const initial = {
          email: user.email,
          displayName: user.displayName || null,
          tabAccess: user.email === OWNER_EMAIL
            ? { business: true, projects: true }
            : DEFAULT_TAB_ACCESS,
          createdAt: serverTimestamp(),
        };
        try {
          await setDoc(ref, initial);
        } catch (e) { console.warn('user doc create:', e.message); }
      }
      unsub = onSnapshot(
        ref,
        (snap) => {
          if (snap.exists()) {
            const d = snap.data();
            setTabAccess(d.tabAccess || DEFAULT_TAB_ACCESS);
          } else {
            setTabAccess(DEFAULT_TAB_ACCESS);
          }
          setLoading(false);
        },
        (err) => {
          console.error('tab access listener:', err);
          setLoading(false);
        }
      );
    })();
    return () => { if (unsub) unsub(); };
  }, [user]);

  return { tabAccess, loading };
}
